
<template>



   
<div>
	
	<head>
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width, initial-scale=1">
	<title>EPET N° 16</title>
	<link rel="stylesheet" href="css/font-awesome.min.css">
	<link rel="stylesheet" href="css/normalize.css">
	<link rel="stylesheet" href="css/bootstrap.min.css">
	<link href='http://fonts.googleapis.com/css?family=PT+Sans+Narrow' rel='stylesheet' type='text/css'>
	<link href='http://fonts.googleapis.com/css?family=Fjalla+One' rel='stylesheet' type='text/css'>
	<link rel="stylesheet" href="css/style.css">
	
</head>


    



   



<i class="btn-up fa fa-arrow-circle-o-up hidden-xs"></i>
	<!--======================================== Navegación ========================================-->
	


    <section class="full-reset" style="background-color: #fff; padding: 20px 0;">
		<div class="container">
			<div class="row">
				
				<section class="col-xs-12 col-sm-8 col-md-9 info-section-ins">
					<!--======================================== Mision y vision ========================================-->
					<article class="full-reset" id="mision-vision">
						<div class="page-header" style="margin-bottom:40px;">
						  <h1><i class="fa fa-graduation-cap"></i> &nbsp; Misión y Vision</h1>
						</div>
						<br><br>
						<div class="panel panel-primary">
						  <div class="panel-heading lead text-center titles">Misión</div>
						  <div class="panel-body">
						    <p class="lead text-justify">	
							Formar integralmente a jóvenes técnicos, líderes en la gestión de la investigación e información, competentes en las áreas tecnológicas.
							</p>
						  </div>
						</div>
						<br><br>
						<div class="panel panel-primary">
						  <div class="panel-heading lead text-center titles">Visión</div>
						  <div class="panel-body">
						    <p class="lead text-justify">
							Promover y facilitar el desarrollo de la independencia de los alumnos, fomentando su autonomía en diferentes aspectos de su comportamiento, como persona libre y responsable, brindar estímulos y exigir actuar con creatividad para enfrentar situaciones nuevas, con el refuerzo de los valores para accionar hacia el liderazgo en su vida profesional.
							</p>
						  </div>
						</div>	
					</article>
					<!--======================================== Reseña historica ========================================-->
					<article class="full-reset" id="resena-ins">
						<div class="page-header" style="margin-bottom:50px;">
						  <h1><i class="fa fa-university"></i> &nbsp; Reseña histórica</h1>
						</div>
						<h3 class="text-center titles text-uppercase"></h3>
						<p class="lead text-justify">
							La Escuela Provincial de Educación Técnica Nº 16, con orientación en ELECTROMECANICA, está ubicada en Rincón de los Sauces, Departamento Pehuenches en la Provincia del Neuquén. El titulo con el que egresan los alumnos es de TECNICO MECÁNICO ELECTRICISTA.
La sociedad de la localidad la integran individuos de diferentes lugares del País y en su minoría nativos de la provincia. Una parte importante de la comunidad se sustenta de la explotación de hidrocarburos y en menor medida se desempeña en administración pública, comercio, etc. 
La Institución surge como producto del reclamo de la comunidad de Rincón de los Sauces y como respuesta a la demanda de matrícula del nivel medio. Fue fundada el 04 de abril del 2003 para poder satisfacer dicha demanda, con la apertura de dos primeros años con una matrícula de 60 alumnos aproximadamente.
Las clases se iniciaron en turno mañana, tarde y vespertino, en teoría con todas sus dependencias en edificio sito en Auca Mahuida 1047, los talleres inician sus clases en el nuevo edificio cito en calle JM Güemes y Rio Negro, Educación Física se dictaba en el polideportivo Municipal y en el SAF del CEPEM 24. (Se comienza con muchas horas cátedras y cargos sin cubrir) y con problemas de mantenimiento que generan pérdidas de clases.
El establecimiento sigue crecimiento y sufriendo falta de materiales, herramientas, espacios y personal. Situación que hoy en día perdura.
Los alumnos que asisten a esta escuela son adolescentes de entre 12 y 20 años de edad siendo los mismos de clase media y baja con muy poca contención familiar, debido a que en la mayoría de los hogares la mama y el papa trabajan y están muchas horas fuera de la casa.
	Rincón de los Sauces es una localidad joven, que se ve desbordada por el constante crecimiento poblacional, razón por la que no se encuentra preparada para atender y satisfacer las demandas psicofísicas del adolescente.							
						</p>																		
					</article>
					<!--======================================== Ubicacion geografica ========================================-->
					<article class="full-reset" id="ubicacion-ins">
						<div class="page-header">
						  <h1><i class="fa fa-map"></i> &nbsp; Ubicación geográfica</h1>
						
						<p class="lead text-justify">
							Rincón de los Sauces es una ciudad ubicada en el departamento Pehuenches en el noreste de la provincia del Neuquén, en la Patagonia argentina.
							La ciudad se encuentra a 206 km de la capital provincial.
							</p>
						
						<h3 class="text-center titles"><i class="fa fa-map-marker"></i> &nbsp; Mapa de localización</h3>
						<br>
						<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4338.324935274147!2d-68.93075512517656!3d-37.39474788767442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96737ff4d3e614dd%3A0xa0c6b7615a09b154!2sE.P.E.T.%2016!5e1!3m2!1ses-419!2sar!4v1635455403682!5m2!1ses-419!2sar" width="800" height="600" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
						
						</div>
						
					</article>
				</section>
				<!--======================================== Navegacion fija lateral derecha ========================================-->
							
				
					
			</div>
		</div>
	</section>
	
   
   
</div>

 


	
</template>
<script>




export default {
  name: "Institucion",
  components: {
   
  }
};

</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/Institucion.vue